<template>
  <div>
    <div
      v-if="last_searches.length < 1 && latest_searched_companies.length < 1 && saved_searches.length < 1"
      class="div-align-center"
    >
      <img
        class="img-marketing"
        :src="marketing_img_src"
      >
    </div>
    <div v-if="last_searches.length > 0">
      <p class="p4">
        {{ locales.latest_search }}
      </p>
      <div class="card">
        <div class="card-content suggestions-grid">
          <a
            v-for="last_search in last_searches"
            :key="last_search"
            href="#"
            @click.prevent="handleClick(last_search)"
          >
            {{ last_search }}
          </a>
        </div>
      </div>
    </div>
    <div v-if="latest_searched_companies.length > 0">
      <p class="p4">
        {{ locales.latest_company_search }}
      </p>
      <div class="card">
        <div class="card-content suggestions-grid">
          <a
            v-for="latest_searched_company in latest_searched_companies"
            :key="latest_searched_company.name"
            :href="latest_searched_company.path"
          >
            {{ latest_searched_company.name }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InspirationBoard',
  props: {
    locales: {
      type: Object,
      default: () => {}
    },
    marketing_img_src: {
      type: String,
      default: ''
    },
    saved_searches: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      last_searches: [],
      latest_searched_companies: []
    }
  },
  mounted() {
    if (window.getCookie('latest-search')) {
      this.last_searches = JSON.parse(window.getCookie('latest-search'))
    }
    if (window.getCookie('latest-company-search')) {
      this.latest_searched_companies = JSON.parse(window.getCookie('latest-company-search'))
    }
  },
  methods: {
    handleClick(last_search) {
      this.$parent.$emit('handleOnEnter', last_search)
    }
  }
}
</script>